import { Modal, Button, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';

export default function ModalPerfil(props: any) {

    const [nome, setNome] = useState<string>('')
    //const [email, setEmail] = useState<string>('')

    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')

    useEffect(() => {

		if (dadosUsuarios) {

			var dados = JSON.parse(dadosUsuarios)
		    setNome(dados.nome)
            
	

		}

	}, [dadosUsuarios])




  return (
    <Modal
      size="lg"
      //centered
      show={props.show}
      onHide={() => props.setShow(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>Meu perfil</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Row className="align-items-center">

          {/* Avatar */}
          <Col xs="auto">
            <img
              src="/assets/images/avatars/avatarDefault.png"
              alt="Avatar"
              style={{
                width: 90,
                height: 90,
                borderRadius: '50%',
                padding: 4,
                boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
              }}
            />
          </Col>

          {/* Infos */}
          <Col>
            <h5 className="fw-bold mb-1">{nome}</h5>
              {/*
            <div style={{ fontSize: 14, color: '#6c757d' }}>
              {email}
            </div>
            */}

            {/* Linha extra opcional
            <div style={{ fontSize: 13, color: '#adb5bd', marginTop: 4 }}>
              Perfil do usuário
            </div>
             */}
          </Col>

        </Row>

      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.setShow(false)}>
          Fechar
        </Button>

        <Button variant="primary" disabled>
          Editar perfil
        </Button>
      </Modal.Footer>
    </Modal>
  );
}